// extracted by mini-css-extract-plugin
export default {"container":"EmptyList_container__BPS7a"};